import '/app/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "tinyOffset8": "chunk-page-by-city-a2fb74fd-tinyOffset8-WXUgJq",
  "wideOffset3": "chunk-page-by-city-a2fb74fd-wideOffset3-WXUgJq",
  "tiny10": "chunk-page-by-city-a2fb74fd-tiny10-WXUgJq",
  "defaultOffset9": "chunk-page-by-city-a2fb74fd-defaultOffset9-WXUgJq",
  "grid": "chunk-page-by-city-a2fb74fd-grid-WXUgJq",
  "xwide2": "chunk-page-by-city-a2fb74fd-xwide2-WXUgJq",
  "defaultOffset8": "chunk-page-by-city-a2fb74fd-defaultOffset8-WXUgJq",
  "confined6": "chunk-page-by-city-a2fb74fd-confined6-WXUgJq",
  "tinyOffset0": "chunk-page-by-city-a2fb74fd-tinyOffset0-WXUgJq",
  "confinedOffset8": "chunk-page-by-city-a2fb74fd-confinedOffset8-WXUgJq",
  "confinedOffset10": "chunk-page-by-city-a2fb74fd-confinedOffset10-WXUgJq",
  "defaultOffset11": "chunk-page-by-city-a2fb74fd-defaultOffset11-WXUgJq",
  "xwideOffset2": "chunk-page-by-city-a2fb74fd-xwideOffset2-WXUgJq",
  "xwide7": "chunk-page-by-city-a2fb74fd-xwide7-WXUgJq",
  "confinedOffset9": "chunk-page-by-city-a2fb74fd-confinedOffset9-WXUgJq",
  "tiny8": "chunk-page-by-city-a2fb74fd-tiny8-WXUgJq",
  "default5": "chunk-page-by-city-a2fb74fd-default5-WXUgJq",
  "defaultOffset2": "chunk-page-by-city-a2fb74fd-defaultOffset2-WXUgJq",
  "confined5": "chunk-page-by-city-a2fb74fd-confined5-WXUgJq",
  "default0": "chunk-page-by-city-a2fb74fd-default0-WXUgJq",
  "confinedOffset6": "chunk-page-by-city-a2fb74fd-confinedOffset6-WXUgJq",
  "tinyOffset9": "chunk-page-by-city-a2fb74fd-tinyOffset9-WXUgJq",
  "confinedOffset1": "chunk-page-by-city-a2fb74fd-confinedOffset1-WXUgJq",
  "xwideOffset0": "chunk-page-by-city-a2fb74fd-xwideOffset0-WXUgJq",
  "xwideOffset1": "chunk-page-by-city-a2fb74fd-xwideOffset1-WXUgJq",
  "wideOffset1": "chunk-page-by-city-a2fb74fd-wideOffset1-WXUgJq",
  "xwideOffset6": "chunk-page-by-city-a2fb74fd-xwideOffset6-WXUgJq",
  "xwide3": "chunk-page-by-city-a2fb74fd-xwide3-WXUgJq",
  "tinyOffset11": "chunk-page-by-city-a2fb74fd-tinyOffset11-WXUgJq",
  "confinedOffset11": "chunk-page-by-city-a2fb74fd-confinedOffset11-WXUgJq",
  "wide12": "chunk-page-by-city-a2fb74fd-wide12-WXUgJq",
  "defaultOffset7": "chunk-page-by-city-a2fb74fd-defaultOffset7-WXUgJq",
  "tinyOffset2": "chunk-page-by-city-a2fb74fd-tinyOffset2-WXUgJq",
  "default11": "chunk-page-by-city-a2fb74fd-default11-WXUgJq",
  "default9": "chunk-page-by-city-a2fb74fd-default9-WXUgJq",
  "confined8": "chunk-page-by-city-a2fb74fd-confined8-WXUgJq",
  "armstrongGridContainer": "chunk-page-by-city-a2fb74fd-armstrongGridContainer-WXUgJq",
  "wide3": "chunk-page-by-city-a2fb74fd-wide3-WXUgJq",
  "confinedOffset5": "chunk-page-by-city-a2fb74fd-confinedOffset5-WXUgJq",
  "default3": "chunk-page-by-city-a2fb74fd-default3-WXUgJq",
  "standardGridContainer": "chunk-page-by-city-a2fb74fd-standardGridContainer-WXUgJq",
  "confinedOffset0": "chunk-page-by-city-a2fb74fd-confinedOffset0-WXUgJq",
  "confined4": "chunk-page-by-city-a2fb74fd-confined4-WXUgJq",
  "wideOffset0": "chunk-page-by-city-a2fb74fd-wideOffset0-WXUgJq",
  "xwide0": "chunk-page-by-city-a2fb74fd-xwide0-WXUgJq",
  "confinedOffset7": "chunk-page-by-city-a2fb74fd-confinedOffset7-WXUgJq",
  "wide1": "chunk-page-by-city-a2fb74fd-wide1-WXUgJq",
  "confined11": "chunk-page-by-city-a2fb74fd-confined11-WXUgJq",
  "wideOffset5": "chunk-page-by-city-a2fb74fd-wideOffset5-WXUgJq",
  "wide10": "chunk-page-by-city-a2fb74fd-wide10-WXUgJq",
  "wideOffset9": "chunk-page-by-city-a2fb74fd-wideOffset9-WXUgJq",
  "tinyOffset1": "chunk-page-by-city-a2fb74fd-tinyOffset1-WXUgJq",
  "default6": "chunk-page-by-city-a2fb74fd-default6-WXUgJq",
  "wideOffset10": "chunk-page-by-city-a2fb74fd-wideOffset10-WXUgJq",
  "xwideOffset7": "chunk-page-by-city-a2fb74fd-xwideOffset7-WXUgJq",
  "tiny12": "chunk-page-by-city-a2fb74fd-tiny12-WXUgJq",
  "confined1": "chunk-page-by-city-a2fb74fd-confined1-WXUgJq",
  "defaultOffset3": "chunk-page-by-city-a2fb74fd-defaultOffset3-WXUgJq",
  "confined2": "chunk-page-by-city-a2fb74fd-confined2-WXUgJq",
  "xwide12": "chunk-page-by-city-a2fb74fd-xwide12-WXUgJq",
  "xwideOffset4": "chunk-page-by-city-a2fb74fd-xwideOffset4-WXUgJq",
  "default7": "chunk-page-by-city-a2fb74fd-default7-WXUgJq",
  "default4": "chunk-page-by-city-a2fb74fd-default4-WXUgJq",
  "xwideOffset11": "chunk-page-by-city-a2fb74fd-xwideOffset11-WXUgJq",
  "xwide4": "chunk-page-by-city-a2fb74fd-xwide4-WXUgJq",
  "defaultOffset10": "chunk-page-by-city-a2fb74fd-defaultOffset10-WXUgJq",
  "tiny11": "chunk-page-by-city-a2fb74fd-tiny11-WXUgJq",
  "defaultOffset4": "chunk-page-by-city-a2fb74fd-defaultOffset4-WXUgJq",
  "tinyOffset10": "chunk-page-by-city-a2fb74fd-tinyOffset10-WXUgJq",
  "defaultOffset6": "chunk-page-by-city-a2fb74fd-defaultOffset6-WXUgJq",
  "xwide8": "chunk-page-by-city-a2fb74fd-xwide8-WXUgJq",
  "gridContainer": "chunk-page-by-city-a2fb74fd-gridContainer-WXUgJq",
  "wideGridContainer": "chunk-page-by-city-a2fb74fd-wideGridContainer-WXUgJq",
  "confined3": "chunk-page-by-city-a2fb74fd-confined3-WXUgJq",
  "xwideOffset10": "chunk-page-by-city-a2fb74fd-xwideOffset10-WXUgJq",
  "default2": "chunk-page-by-city-a2fb74fd-default2-WXUgJq",
  "wideOffset6": "chunk-page-by-city-a2fb74fd-wideOffset6-WXUgJq",
  "default10": "chunk-page-by-city-a2fb74fd-default10-WXUgJq",
  "tiny3": "chunk-page-by-city-a2fb74fd-tiny3-WXUgJq",
  "tinyOffset4": "chunk-page-by-city-a2fb74fd-tinyOffset4-WXUgJq",
  "xwideOffset3": "chunk-page-by-city-a2fb74fd-xwideOffset3-WXUgJq",
  "tiny0": "chunk-page-by-city-a2fb74fd-tiny0-WXUgJq",
  "confined0": "chunk-page-by-city-a2fb74fd-confined0-WXUgJq",
  "tinyOffset5": "chunk-page-by-city-a2fb74fd-tinyOffset5-WXUgJq",
  "default12": "chunk-page-by-city-a2fb74fd-default12-WXUgJq",
  "confined9": "chunk-page-by-city-a2fb74fd-confined9-WXUgJq",
  "tiny2": "chunk-page-by-city-a2fb74fd-tiny2-WXUgJq",
  "wide8": "chunk-page-by-city-a2fb74fd-wide8-WXUgJq",
  "wideOffset4": "chunk-page-by-city-a2fb74fd-wideOffset4-WXUgJq",
  "wide9": "chunk-page-by-city-a2fb74fd-wide9-WXUgJq",
  "tiny6": "chunk-page-by-city-a2fb74fd-tiny6-WXUgJq",
  "xwide5": "chunk-page-by-city-a2fb74fd-xwide5-WXUgJq",
  "tinyOffset7": "chunk-page-by-city-a2fb74fd-tinyOffset7-WXUgJq",
  "confinedOffset2": "chunk-page-by-city-a2fb74fd-confinedOffset2-WXUgJq",
  "default1": "chunk-page-by-city-a2fb74fd-default1-WXUgJq",
  "default8": "chunk-page-by-city-a2fb74fd-default8-WXUgJq",
  "wide7": "chunk-page-by-city-a2fb74fd-wide7-WXUgJq",
  "xwide9": "chunk-page-by-city-a2fb74fd-xwide9-WXUgJq",
  "xwide1": "chunk-page-by-city-a2fb74fd-xwide1-WXUgJq",
  "xwide11": "chunk-page-by-city-a2fb74fd-xwide11-WXUgJq",
  "wide11": "chunk-page-by-city-a2fb74fd-wide11-WXUgJq",
  "wide5": "chunk-page-by-city-a2fb74fd-wide5-WXUgJq",
  "xwideOffset5": "chunk-page-by-city-a2fb74fd-xwideOffset5-WXUgJq",
  "xwideOffset8": "chunk-page-by-city-a2fb74fd-xwideOffset8-WXUgJq",
  "tiny9": "chunk-page-by-city-a2fb74fd-tiny9-WXUgJq",
  "confined7": "chunk-page-by-city-a2fb74fd-confined7-WXUgJq",
  "defaultOffset1": "chunk-page-by-city-a2fb74fd-defaultOffset1-WXUgJq",
  "confined12": "chunk-page-by-city-a2fb74fd-confined12-WXUgJq",
  "xwide6": "chunk-page-by-city-a2fb74fd-xwide6-WXUgJq",
  "tinyOffset3": "chunk-page-by-city-a2fb74fd-tinyOffset3-WXUgJq",
  "tiny7": "chunk-page-by-city-a2fb74fd-tiny7-WXUgJq",
  "confinedOffset3": "chunk-page-by-city-a2fb74fd-confinedOffset3-WXUgJq",
  "row": "chunk-page-by-city-a2fb74fd-row-WXUgJq",
  "col": "chunk-page-by-city-a2fb74fd-col-WXUgJq",
  "wideOffset7": "chunk-page-by-city-a2fb74fd-wideOffset7-WXUgJq",
  "xwide10": "chunk-page-by-city-a2fb74fd-xwide10-WXUgJq",
  "confinedOffset4": "chunk-page-by-city-a2fb74fd-confinedOffset4-WXUgJq",
  "tinyOffset6": "chunk-page-by-city-a2fb74fd-tinyOffset6-WXUgJq",
  "tiny5": "chunk-page-by-city-a2fb74fd-tiny5-WXUgJq",
  "confined10": "chunk-page-by-city-a2fb74fd-confined10-WXUgJq",
  "wide0": "chunk-page-by-city-a2fb74fd-wide0-WXUgJq",
  "wideOffset11": "chunk-page-by-city-a2fb74fd-wideOffset11-WXUgJq",
  "defaultOffset5": "chunk-page-by-city-a2fb74fd-defaultOffset5-WXUgJq",
  "tiny1": "chunk-page-by-city-a2fb74fd-tiny1-WXUgJq",
  "wide4": "chunk-page-by-city-a2fb74fd-wide4-WXUgJq",
  "wide2": "chunk-page-by-city-a2fb74fd-wide2-WXUgJq",
  "wideOffset2": "chunk-page-by-city-a2fb74fd-wideOffset2-WXUgJq",
  "wideOffset8": "chunk-page-by-city-a2fb74fd-wideOffset8-WXUgJq",
  "tiny4": "chunk-page-by-city-a2fb74fd-tiny4-WXUgJq",
  "wide6": "chunk-page-by-city-a2fb74fd-wide6-WXUgJq",
  "xwideOffset9": "chunk-page-by-city-a2fb74fd-xwideOffset9-WXUgJq"
};